import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import _map from 'lodash/map';
import _uniqBy from 'lodash/uniqBy';
import Spinner from '../../../shared/spinner';
import dayjs from 'dayjs';
import DayPicker from 'react-day-picker';
import _filter from 'lodash/filter';
import _findIndex from 'lodash/findIndex';
import { CYOA_NETWORK_IDS } from '../../../../config';

class Calender extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      minDate:"",
      maxDate:"",
      currentDate:"",
      enabledDateOriginal:[],
      selectdropdownValue:"",
      selectdropdownMonths:[],
      months:["January", "February", "March","April","May","June","July","August","September","October","November","December"],
      isYearOpen:false,
      calendarReady:false
    }

    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  componentDidMount(){
    this.setupCalender();
    document.body.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "calender"){
        if(this.state.isYearOpen) this.setState({isYearOpen: false});
      }
    }catch(e){}

  }

  monthSelectHelper(data, iscyoa = false){
    if (data.length > 0) {
      let uniqueMonth = _uniqBy(data, (item) => {
        return dayjs(!iscyoa ? item.departure_date : item).format("YYYY-MM")
      });
      let monthMap = _map(uniqueMonth, (item) => {
        return dayjs(!iscyoa ? item.departure_date : item).format('MMMM') + " " + dayjs(!iscyoa ? item.departure_date : item).format('YYYY');
      });
      return monthMap;
    }else{
      return [dayjs().format('MMMM') + " " + dayjs().format('YYYY')];
    }
  }


  setupCalender(){

    const { sectors, itineraries:{content:{date_start, nr_days}} } = this.props;


    if(date_start === undefined) return;

    //Populate calender tour dates
    let months = [date_start, dayjs(date_start).add(nr_days, 'd').format('YYYY-MM-DD')];


    this.setState({
      minDate:new Date(date_start),
      maxDate:new Date(dayjs(date_start).add(nr_days, 'd').format('YYYY-MM-DD')),
      currentDate:new Date(date_start),
      selectdropdownMonths:this.monthSelectHelper(months, true), //populate avaiable months for calender dropdown and show current calender months for tours with no dates
      enabledDateOriginal: sectors.map(item => { return {'city':item.name,'date':item.transfer.date_for, 'tour_id':item.tour_id }})  //name and start dates
    }, () => {

      //avoids error message FOUC
     this.setState({
       calendarReady:true
     });

    });

  }


  handleMonthClick = (day) => {

    this.setState({
      selectdropdownValue:dayjs(day).format('MMMM YYYY'),
      currentDate:new Date(day)
    });
  }

  renderCity(day){

    const { enabledDateOriginal} = this.state;

    let dayMod = dayjs(day).format('YYYY-MM-DD');
    let index =  _findIndex(enabledDateOriginal, (i) => i.date === dayMod)
    let city = _filter(enabledDateOriginal, ['date', dayMod]);

    if(index !== - 1){
      return city.map((item, i) => { return <Fragment key={i}><span className={`bar ${(item.tour_id !== CYOA_NETWORK_IDS["europe"].id && item.tour_id !== CYOA_NETWORK_IDS["usa"].id) ? "product" : "" }`}>{item.city}</span><br /></Fragment>})
    }else{
      return <span>&nbsp;</span>;
    }
  }


  renderDay(day){
    const date = day.getDate();

    return(
      <div>
        {date}
        <div className="calender-city">
          { this.renderCity(day) }
        </div>
      </div>
    )
  }

  handleYearMonthChange = (e, value) => {

    const _month = value.split(" ")[0];
    const _year = value.split(" ")[1];
    const _monthIndex = this.state.months.indexOf(_month);

    // Set the current drop down menu value and current calender date
    this.setState({
      selectdropdownValue:value,
      currentDate:new Date(_year, _monthIndex),
      isYearOpen:false
    });

  }

  onYearClick(e){
    e.preventDefault();
    this.setState({isYearOpen:!this.state.isYearOpen});
  }

  YearMonthForm(){
    const { isYearOpen, selectdropdownMonths, currentDate } = this.state;
    const currentMonth = dayjs(currentDate).format('MMMM YYYY');

    return (
      <form className="DayPicker-Caption">
         <div className="row">
          <div className="column small-6 medium-4 large-3 small-centered">
            <div className="filterDropdown basket">
              <div className="row">
                <div className="columns small-12">
                  <a onClick={ e => this.onYearClick(e) } className="filterDropdown-btn calender">
                  {currentMonth}
                  <i className={`fa fa-chevron-down ${isYearOpen ? 'active' : ''}`} aria-hidden="true"></i>
                  </a>
                </div>
                <div className="columns small-12">
                  <ul className="calender" style={{display: isYearOpen ? 'block':'none' }}>
                    {
                      selectdropdownMonths.map((value, index) => {
                        return (
                          <li
                            value={value}
                            onClick={e => this.handleYearMonthChange(e, value)}
                            key={index}>{value}
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
            </div>

         </div>
        </div>

      </form>
    )
  }


  render(){

    const { minDate, maxDate, currentDate, calendarReady } = this.state;


   if(!calendarReady){
     return ( <Spinner text="loading..." loadClass="orange-spinner-wrapper"  /> );
   }else{
      return (
        <React.Fragment>
          <DayPicker
            className="calendar-cyoa"
            showOutsideDays
            firstDayOfWeek={1}
            numberOfMonths={1}
            fromMonth={(minDate || null )}
            toMonth={(maxDate || null )}
            month={(currentDate || null)}
            onMonthChange={this.handleMonthClick}
            canChangeMonth={true}
            renderDay={this.renderDay.bind(this)}
            captionElement={this.YearMonthForm.bind(this)}
            weekdaysShort={['SUN', 'MON', 'TUES', 'WED', 'THU', 'FRI', 'SAT']}
          />
        </React.Fragment>
      )
   }
  }

}


function mapStateToProps(state){
  return{
    itineraries:state.itineraries.data,
    sectors:state.itineraries.data.sectors
  }
}



export default connect(mapStateToProps, null)(Calender);



// WEBPACK FOOTER //
// ./src/components/itinerary/details/components/calender-cyao.js